/* eslint-disable arrow-body-style */
import React from 'react';

export const FilterPanelHeader = () => <h5>Filters</h5>;
